import { ChequeListPayload } from 'src/redux/slices/cheque-management';

export function formatChequeListParams(
  params: ChequeListPayload
): URLSearchParams {
  const urlParams = new URLSearchParams();

  // manual ordered keys
  if (params.cheque_no !== undefined && params.cheque_no !== null) {
    urlParams.set('cheque_no', String(params.cheque_no));
  }
  if (params.dr_no !== undefined && params.dr_no !== null) {
    urlParams.set('dr_no', String(params.dr_no));
  }
  if (params.liability !== undefined && params.liability !== null) {
    urlParams.set('liability', String(params.liability));
  }
  if (params.pdc_date_from !== undefined && params.pdc_date_from !== null) {
    urlParams.set('pdc_date_from', String(params.pdc_date_from));
  }
  if (params.pdc_date_to !== undefined && params.pdc_date_to !== null) {
    urlParams.set('pdc_date_to', String(params.pdc_date_to));
  }
  if (params.page !== undefined && params.page !== null) {
    urlParams.set('page', String(params.page));
  }

  // add any other remaining keys
  Object.entries(params).forEach(([key, value]) => {
    if (
      ![
        'cheque_no',
        'dr_no',
        'liability',
        'pdc_date_from',
        'pdc_date_to',
        'page'
      ].includes(key) &&
      value !== undefined &&
      value !== null
    ) {
      urlParams.set(key, String(value));
    }
  });

  return urlParams;
}
